import apiService from '../../apiService'
import Notification from '../../../../../../../resources/js/notification'

/**
 * @deprecated
 */
export default {
  namespaced: true,
  state: {
    projects: {},
    selectedClientId: null
  },
  mutations: {
    setProjects (state, projects) {
      state.projects = projects
    },
    setSelectedClientId (state, clientId) {
      state.selectedClientId = clientId
    }
  },
  actions: {
    fetch ({ commit }) {
      apiService.getProjects()
        .then(response => {
          commit('setProjects', response.data)
          window.vue.$emit('projectsLoaded')
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список всех проектов.'
          })
        })
    },
    changeSelectedClientId ({ commit }, clientId) {
      if (clientId) {
        localStorage.setItem('selectedClientId', clientId)
      } else {
        localStorage.removeItem('selectedClientId')
      }

      commit('setSelectedClientId', clientId)
      window.vue.$emit('clientIdSelected')
    }
  },
  getters: {
    getClientLogin: state => (id, domain) => {
      return state.projects[id][domain].login
    }
  }
}
